import { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

// Replaces the v5-only `react-router-scroll-top`: scroll to top on every
// route change.
export default function ScrollToTop({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return children;
}

ScrollToTop.propTypes = {
  children: PropTypes.node,
};
